// extracted by mini-css-extract-plugin
module.exports = {"tallink-silja-logo":"TallinkSiljaLogo_tallink-silja-logo__3TAMt"};